export function useIsJim() {
    const isJim = () => {
        return window.currentUser && window.currentUser.username === 'chartbook';
    };

    return {
        isJim
    };
};
